import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { BOOK_DEMO_URL, EASE } from "../../lib/motion";

// Full-width charcoal CTA band with taupe display text and a Book a Demo button.
export const CtaBand = ({ eyebrow = "Let's talk", title, testid = "cta-band" }) => {
  return (
    <section data-testid={testid} className="relative bg-[#1C1C1E] py-24 md:py-36 overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "linear-gradient(to right,#B39B77 1px,transparent 1px),linear-gradient(to bottom,#B39B77 1px,transparent 1px)",
          backgroundSize: "72px 72px",
        }}
      />
      <div className="relative max-w-[1440px] mx-auto px-6 md:px-12 lg:px-24 text-center">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: EASE }}
          className="font-body text-xs uppercase tracking-[0.28em] text-[#B39B77]/70 mb-7"
        >
          {eyebrow}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: EASE, delay: 0.1 }}
          className="font-display font-semibold text-[#B39B77] text-3xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight max-w-4xl mx-auto"
        >
          {title}
        </motion.h2>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: EASE, delay: 0.25 }}
          className="mt-11"
        >
          <a
            href={BOOK_DEMO_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`${testid}-book-demo`}
            className="group inline-flex items-center gap-2 rounded-full bg-[#B39B77] px-8 py-4 font-body text-base font-medium text-[#1C1C1E] transition-colors duration-300 hover:bg-[#96805E]"
          >
            Book a Demo
            <ArrowUpRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </motion.div>
      </div>
    </section>
  );
};
